import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';

export default function O() {
    const { useLang } = useGlobal();
    const { t } = useLang('PowerOcean.O');

    const tags: string[] = [t('tag1'), t('tag2'), t('tag3'), t('tag4'), t('tag5'), t('tag6'), t('tag7'), t('tag8')];

    return (
        <div className={`power-ocean-home-O ${styles['power-ocean-home-O']}`}>
            <div className="sec15">
                <h2 className="title">
                    {t('title')}
                    <span className="desc">{t('desc')}</span>
                </h2>
                <div className="img-box">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1768984076063/15.png"
                        pad="https://websiteoss.ecoflow.com/upload/image/1768984075898/15-h5.png"
                        alt={t`EcoFlow PowerOcean Three-phase`}
                    />
                </div>
                <div className="tags">
                    {tags?.map((tag: string) => (
                        <span className="tag" key={tag}>
                            {tag}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
}
